module.exports = __webpack_public_path__ + "media/images/icons/country_flags/my-18a21ce12040947912daf9525c150a4a.svg";